













































































































































































































































import { Vue } from 'vue-property-decorator';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import NOC from '@/class/common/const';

import ConfrimDialog from '@/parts/app/ConfrimDialog.vue';
import QuitLoginModal from '@/parts/account/QuitLoginModal.vue';
// import SideBar from '@/parts/app/SideBar.vue';
import TopBar from '@/parts/app/TopBar2.vue';
import apps from '@/parts/app/disp/index';

import * as models from '@/class/models/views/app';
import * as modelsNews from '@/class/models/views/news';
import * as modelsAlert from '@/class/models/views/alert';
import API from '@/api/common';
import isMobile from 'ismobilejs';
import Footer from '@/components/Footer.vue';

interface Data {
  appData: models.CApp;
  routerClick: boolean;
  disp: string;
  errormodal: boolean;
  forgetmodal: boolean;
  confirmmodal: boolean;
  modal: boolean;
  modalMessage: string;
  dispClick: boolean;
  ownerFlag: boolean;
  error: any;
  nowPath: string;
  appClass: string;
  invitationData: { mail: string, code: string };
  newsList: [];
  alertCount: number;
  ModalValue: any;
  quitLoginModal: boolean;
  quitLoginDisplay: string;
  notLoggedInScreens: string[];
  logoutModal: boolean;
  isProcessing: boolean;
}

interface Methods {
  changeMode: (mode: string) => void;
  forgetModal: (mode: string) => void;
  errorModal: (message: string) => void;
  showModal: (message: string) => void;
  onClickMoveWELCOME: () => void;
  confirmDialog: (message: string, cancelVisible: boolean) => Promise<any>;
  check: () => Promise<void>;
  signup: (data: any) => Promise<void>;
  login: (value: any) => Promise<void>;
  openLogoutModal: () => void;
  closeLogoutModal: () => void;
  closeQuitModal: () => void;
  logout: () => Promise<void>;
  confirm: (editData: models.INewAccount) => Promise<void>;
  invitation: (value: any) => Promise<void>;
  pushPath: (path: string) => void;
  forget: (mail: string) => Promise<void>;
  changePass: (value: any) => Promise<void>;
  getDocument: () => Promise<void>;
  getNewsList: () => Promise<void>;
  checkNews: (clickedNews: any) => void;
  checkAlert: (count: number) => void;
  addGtm: () => void;
  deleteGtm: () => void;
  changeContract: () => Promise<void>;
  parentMethod: (gaget: any) => void;
  isAccountOnlyContract: (contract: string) => boolean;
}

interface Computed {
  APP_MODE: any;
  isPhone: boolean;
  loggedIn: boolean;
}

export default Vue.extend({
  name: 'app',
  metaInfo: {
    title: 'RemoLabo｜リモートワークツールを簡単に導入・解決！！',
    meta: [
      { httpEquiv: 'X-UA-Compatible', content: 'IE=edge' },
      { name: 'viewport', content: 'width=device-width,initial-scale=1.0,minimum-scale=1.0' },
      { property: 'og:title', content: 'RemoLabo｜リモートワーク問題解決' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://remolabo.net/' },
      { property: 'og:image', content: 'https://remolabo.net/images/ogp.jpg' },
      { property: 'og:description', content: 'リモートワークを管理しない。リモラボはリモートワーカーの勤務時間を自動的にグラフ化します。' },
    ],
  },
  components: { TopBar, QuitLoginModal, ...apps, Footer },
  data() {
    return {
      appData: new models.CApp(),
      routerClick: false,
      disp: '',
      errormodal: false,
      forgetmodal: false,
      // signupmodal: false,
      confirmmodal: false,
      modal: false,
      modalMessage: '',
      dispClick: false,
      ownerFlag: false,
      error: {},
      nowPath: '',
      appClass: '',
      invitationData: { mail: '', code: '' },
      newsList: [],
      alertCount: 0,
      ModalValue: {},
      quitLoginModal: false,
      quitLoginDisplay: NOC.CONTRACT.CONFIRM,
      // 未ログイン画面
      notLoggedInScreens: [
        NOC.APP.MODE.SIGNUP,
        NOC.APP.MODE.CONFIRM,
        // NOC.APP.MODE.,
      ],
      logoutModal: false,
      isProcessing: false,
    };
  },
  computed: {
    APP_MODE() {
      return NOC.APP.MODE;
    },
    isPhone() {
      return isMobile().phone;
    },
    // TODO: 未ログインの判定を見直す必要有
    loggedIn() {
      return (!this.notLoggedInScreens.includes(this.disp) && this.appData.name !== '');
    },
  },
  created() {
    this.$router.beforeEach((to: any, from: any, next: any) => {
      // 2どよばれる
      // console.log(to.path)
      let path = to.path.replace('/', '');
      path = to.path.indexOf('help/') > -1 ? 'help' : path; // REMOLABO-413: /help/fooのURLに対応

      // 未認証
      if (this.disp !== NOC.APP.MODE.AUTH) {
        if (path !== 'new') {
          // if (NOC.APP.MODE.DIRECT.indexOf(path) >= 0) {
          //   if (this.disp !== NOC.APP.MODE.AUTH) {
          //     this.disp = path;
          //     next();
          //   } else {
          //     // welcomeになる
          //     next({ path: '' });
          //   }
          // } else {
          //   // welcomeになる
          //   next({ path: '' });
          // }
        }
      // 退会済み/遅延猶予期間/停止
      } else if (this.isAccountOnlyContract(this.appData.contractStatus)) {
        this.ownerFlag = (Number(this.appData.role) === 1);
        if (!this.ownerFlag) { // 労務管理者の場合ログイン画面へ遷移
          this.logout();
        }
        switch (path) {
          case 'account':
            next({ path: '/license' });
            break;
          case 'Invoice':
          case 'contact':
          case 'help':
          case 'news':
          case 'clientTools':
          case 'license':
          case 'subscriberInfo':
            next();
            break;
          default:
            next({ path: '/license' });
            break;
        }
        // 認証済
      } else {
        switch (path) {
          case '':
          case 'graph':
          case 'setting/work_style':
          case 'setting/users':
          case 'setting/group':
          case 'setting/alert':
          case 'setting/work_manage':
          case 'alert':
          // case 'account':
          case 'Invoice':
          case 'contact':
          case 'help':
          case 'news':
          case 'clientTools':
          case 'license':
          case 'subscriberInfo':
            // console.log('aaaXb');
            next();
            break;
          case 'account': // 旧ご契約情報画面
            next({ path: '/license' });
            break;
          default:
            // console.log('aaaX');
            next({ path: '/' });
            break;
        }
      }
    });
  },
  async mounted() {
    // const mobaile = isMobile();
    if (location.pathname.indexOf('/service') > -1) {
      this.disp = 'service';
    } else {
    // } else if (!mobaile.phone) { // REMOLABO-413 スマホ表示に対応
      const mail: any = this.$route.query.mail;
      const code: any = this.$route.query.code;
      const f: any = this.$route.query.f;
      if (
        this.$route.query.mail &&
        this.$route.query.code &&
        this.$route.query.f
      ) {
        // 画面遷移
        this.disp = NOC.APP.MODE.VERIFICATION;
        // 認証
        if (this.$route.query.f !== '3') {
          const api = new API();
          const req = {} as models.VAuth;
          const res = await api.post<any, models.VDisp>(
            'auth/verification',
            this.$route.query,
          );
          if (res.result) {
            this.invitationData.mail = mail;
            this.invitationData.code = code;
            this.disp = res.data.disp;
            // this.$router.push('/', () => {});
          } else {
            this.showModal(
              '登録に失敗しました。メールアドレスを再確認してください。',
            );
            this.disp = NOC.APP.MODE.WELCOME;
            // this.$router.push('/', () => {});
          }
        } else {
          const api = new API();
          const req = {} as models.VAuth;
          const res = await api.post<any, models.VDisp>(
            'auth/changeVerification',
            this.$route.query,
          );
          if (res.result) {
            this.invitationData.mail = mail;
            this.invitationData.code = code;
            this.disp = res.data.disp;
            // this.$router.push('/', () => {});
          } else {
            this.showModal(
              '登録に失敗しました。メールアドレスを再確認してください。',
            );
          }

        }
      } else {
        await this.check();
      }
      this.nowPath = this.$route.path;
    // REMOLABO-413 スマホ表示に対応
    /*
    } else {
      // this.disp = NOC.APP.MODE.WELCOME_PHONE;
      switch (this.$route.path) {
        case `/${NOC.APP.MODE.SIGNUP}`:
          // console.log('sora')
          this.disp = NOC.APP.MODE.SIGNUP;
          break;
        case `/${NOC.APP.MODE.PERSONAL}`:
          this.disp = NOC.APP.MODE.PERSONAL;
          break;
        case `/${NOC.APP.MODE.LOGIN}`:
        case `/new`:
          await this.confirmDialog('スマホでのご利用は現在対応しておりません。\nパソコンからのご利用をお願いいたします。', false);
          window.location.replace('/service/top/');
          break;
        default:
          window.location.replace('/service/top/');
          break;
      }*/

    }
    // this.disp = NOC.APP.MODE.THANKS;
  },
  methods: {
    changeMode(mode: string) {
      if (process.env.VUE_APP_MAINTENANCE === 'true') {
        let nextMode = mode;
        if (
          !(
            mode === NOC.APP.MODE.WELCOME ||
            mode === NOC.APP.MODE.MAINTENANCE ||
            mode === NOC.APP.MODE.ERROR
          )
        ) {
          nextMode = NOC.APP.MODE.MAINTENANCE;
          // console.log('change')
        }
        this.disp = nextMode;
        this.$router.push(`/${nextMode}`, () => {});
      } else {
        this.disp = mode;
        this.$router.push(`/${mode}`, () => {});
      }
    },
    forgetModal(mode: string) {
      this.disp = mode;
      this.$router.push(`/${mode}`, () => {});
      this.forgetmodal = false;
    },
    // signupModal(mode: string) {
    //   this.disp = mode;
    //   this.$router.push(`/${mode}`, () => {});
    //   this.signupmodal = false;
    // },
    errorModal(message: string) {
      this.errormodal = true;
      this.modalMessage = message;
    },
    showModal(message: string) {
      this.modal = true;
      this.modalMessage = message;
    },
    onClickMoveWELCOME() {
      this.disp = NOC.APP.MODE.WELCOME;
      this.forgetmodal = false;
      // this.signupmodal = false;
      // this.$emit('change', this.disp);
    },
    async confirmDialog(message: string, cancelVisible: boolean = true): Promise<any> {
      return await new Promise((resolve) => {
        const VM = Vue.extend(ConfrimDialog);
        return new VM({
          parent: this,
          propsData: {
            message,
            okAction: () => resolve(true),
            cancelAction: () => resolve(false),
            cancelVisible,
          },
        });
      }).catch((err) => {
        throw err;
      });
    },
    async check() {
      // REMOLABO-413 スマホ表示に対応
      // if (isMobile().phone) {
      //   await this.confirmDialog('スマホでのご利用は現在対応しておりません。\nパソコンからのご利用をお願いいたします。', false);
      //   window.location.replace('/service/top/');
      // } else {
      if (process.env.VUE_APP_MAINTENANCE === 'true') {
        this.disp = NOC.APP.MODE.MAINTENANCE;
        this.changeMode(this.disp);
      } else {
        if (localStorage.getItem(NOC.N16.DIR)) {
          // 通信して確認
          const api = new API();
          const res = await api.get<models.VApp>('auth/check');

          // todo:複雑すぎる
          if (res.result) {
            if (res.data) {
              this.appData = res.data.appData;
              if (this.appData.name === '') {
                this.disp = NOC.APP.MODE.CONFIRM;
              } else {
                if (process.env.VUE_APP_PRE !== '1') {
                  // console.log((this.appData.role === 1));
                  this.ownerFlag = (Number(this.appData.role) === 1);
                  const path = location.pathname.replace('/', '');
                  // console.log(path);
                  switch (path) {
                    case '':
                    case 'graph':
                    case 'setting/work_style':
                    case 'setting/work_manage':
                    case 'setting/users':
                    case 'setting/alert':
                    case 'alert':
                      break;
                    default:
                      // 機能していない？
                      break;
                  }
                  this.disp = NOC.APP.MODE.AUTH;
                  if (this.appData.contractStatus === NOC.CONTRACT.DENY) {
                    // 拒否の場合ログアウト
                    this.logout();
                  } else {
                    if (this.isAccountOnlyContract(this.appData.contractStatus)) {
                      // 退会済み/遅延猶予期間/停止
                      if (!this.ownerFlag) { // 労務管理者の場合ログイン画面へ遷移
                        this.logout();
                      }
                      switch (path) {
                        case 'account':
                          await this.$router.push(`/license`, () => {});
                          break;
                        case 'Invoice':
                        case 'contact':
                        case 'help':
                        case 'news':
                        case 'license':
                        case 'clientTools':
                        case 'subscriberInfo':
                          this.nowPath = this.$route.path;
                          break;
                        default:
                          await this.$router.push(`/license`, () => {});
                          break;
                      }
                    } else {
                      const find = path !== NOC.APP.MODE.PERSONAL
                        && NOC.APP.MODE.DIRECT.find((v) => v === path);
                      if (find) {
                        // 認証済みでログイン前画面を開こうとした場合はダッシュボードに遷移
                        await this.$router.push(`/`, () => {});
                      } else {
                        this.nowPath = this.$route.path;
                      }
                    }
                    this.getNewsList();
                  }
                } else {
                  this.disp = NOC.APP.MODE.COMING;
                }
              }
            } else {
              this.disp = NOC.APP.MODE.LOGIN;
            }
          } else {
            // error
            // clear
            localStorage.removeItem(NOC.N16.DIR);
            this.disp = NOC.APP.MODE.ERROR;
            this.changeMode(this.disp);
          }
        } else {
          // console.log('aaab');
          const path = location.pathname.replace('/', '');
          // console.log(path);
          // todo 一覧にあるかどうか
          const find = NOC.APP.MODE.DIRECT.find((v) => v === path);
          this.disp = find ? path : NOC.APP.MODE.WELCOME;
          // console.log(this.disp);
          this.changeMode(this.disp);
          // 未ログイン時gtmタグ追加
          this.addGtm();
        }
      }
      // }
    },
    //
    async signup(data: any) {
      // 通信
      const api = new API();
      const res = await api.post<models.VAuth, any>('auth/signup', data);

      if (res.result) {
        // console.log(res);
        // 通信成功時
        if (!res.data.message) {
          // this.disp = NOC.APP.MODE.THANKS;
          // this.changeMode(this.disp);
          location.href = '/thanks/regist.html';
          // this.signupmodal = true;
        } else {
          this.error = res.data.message;
        }
      } else {
        this.errorModal('登録に失敗しました。');
      }
      // this.disp = flag;
    },
    async login(value: any) {
      const api = new API();
      const res = await api.post<models.VAuth, any>('auth/login', value);

      if (res.result) {
        this.deleteGtm();
        // this.disp = NOC.APP.MODE.AUTH;
        this.appData = res.data.appData;
        if (this.appData.name === '') {
          this.disp = NOC.APP.MODE.CONFIRM;
          // this.$router.push(`/`, () => {});
        } else {
          if (process.env.VUE_APP_PRE !== '1') {
            this.disp = NOC.APP.MODE.AUTH;
            this.ownerFlag = Number(this.appData.role) === 1;
            this.nowPath = this.$route.path;
            this.quitLoginDisplay = NOC.CONTRACT.CONFIRM;
            if (this.appData.contractStatus === NOC.CONTRACT.DENY) {
              // アカウント停止
              this.quitLoginModal = true;
              this.quitLoginDisplay = NOC.CONTRACT.DENY;
              // this.logout();
            } else {
              this.getNewsList();
              if (this.isAccountOnlyContract(this.appData.contractStatus)) {
                // 退会済み/遅延猶予期間/停止
                if (this.ownerFlag) {
                  // 管理者の場合アカウント画面に遷移
                  await this.$router.push(`/license`, () => {});
                } else {
                  // 労務管理者の場合ログインさせない
                  if (this.appData.contractStatus === NOC.CONTRACT.QUIT) {
                    this.quitLoginDisplay = NOC.CONTRACT.QUIT;
                  }
                  this.quitLoginModal = true;
                  // this.logout();
                }
              } else {
                await this.$router.push(`/`, () => {});
              }
            }
          } else {
            this.disp = NOC.APP.MODE.COMING;
          }
        }
      } else {
        this.errorModal('ユーザー名またはパスワードが正しくありません。');
      }
    },
    openLogoutModal() {
      this.logoutModal = true;
    },
    closeLogoutModal() {
      this.logoutModal = false;
    },
    // 利用期間停止|利用停止モーダルを閉じてログアウトを行う処理
    closeQuitModal() {
     this.quitLoginModal = false;
     this.logout();
    },
    async logout() {
      this.logoutModal = false;
      // logout
      const api = new API();
      const res = await api.get<any>('auth/logout');
      // console.log(res);
      if (!res.result) {
        console.log(res);
      }
      localStorage.removeItem(NOC.N16.DIR);
      // this.disp = NOC.APP.MODE.LOGIN;
      this.disp = NOC.APP.MODE.WELCOME;

      this.changeMode(this.disp);

      // ログアウト時gtmタグ追加
      this.addGtm();
    },
    async confirm(editData: models.INewAccount): Promise<void> {
      // メールを合流
      editData.mail = this.appData.mail;
      // api start
      const api = new API();
      this.isProcessing = true;
      const res = await api.post<models.IAccount, any>(
        'auth/confirm',
        editData,
      );
      // result
      if (res.result) {
        // 成功時
        if (process.env.VUE_APP_PRE !== '1') {
          await this.check();
          await this.$router.push(`/`, () => {});
        } else {
          this.disp = NOC.APP.MODE.COMING;
          this.changeMode(this.disp);
        }
      } else {
        // this.$emit('info', '登録できませんでした。');
        this.errorModal('登録できませんでした。');
      }
      this.isProcessing = false;
    },
    async invitation(value: any) {
      const api = new API();
      value.mail = this.invitationData.mail;
      value.code = this.invitationData.code;
      const res = await api.post<models.VAuth, any>('auth/invitation', value);
      if (res.result) {
        // this.disp = NOC.APP.MODE.AUTH;
        if (!res.data.message) {
          this.disp = NOC.APP.MODE.LOGIN;
          this.changeMode(this.disp);
        } else {
          this.error = res.data.message;
        }
      } else {
        this.errorModal('通信できませんでした。');
      }
    },
    pushPath(path: string) {
      // this.$router.push(path, () => {});
      this.nowPath = path;
    },
    async forget(mail: string) {
      const api = new API();
      const res = await api.post<any, any>('auth/forget', { mail });
      if (res.result) {
        // this.disp = NOC.APP.MODE.AUTH;
        // this.disp = NOC.APP.MODE.CHANGE;
        // this.changeMode(this.disp);
        this.forgetmodal = true;
      } else {
        this.errorModal('送信できませんでした。');
      }
    },
    async changePass(value: any) {
      const api = new API();
      const res = await api.post<models.VAuth, any>('auth/change', value);
      if (res.result) {
        // this.disp = NOC.APP.MODE.AUTH;
        this.disp = NOC.APP.MODE.LOGIN;
        this.changeMode(this.disp);
      } else {
        this.errorModal('通信できませんでした。');
      }
    },
    async getDocument() {
      const api = new API();
      const res = await api.get<any>('download/document');
      if (res.result) {
        // this.disp = NOC.APP.MODE.AUTH;
        // this.disp = NOC.APP.MODE.LOGIN;
        // this.changeMode(this.disp);
      } else {
        this.errorModal('通信できませんでした。');
      }
    },
    async getNewsList() {
      const apiGetNews = async () => {
        const api = new API();
        const res = await api.get<any>('news');
        const newsList = res.data.news.filter((news: modelsNews.INews) => {
        if (!news.checked) {
          return news;
        }
        });
        this.newsList = newsList;
      };
      const apiGetAlert = async () => {
        const api = new API();
        const res = await api.get<modelsAlert.VNewsAlertCount>('alert/count');
        this.alertCount = res.data.count;
      };
      await Promise.all([apiGetNews(), apiGetAlert()]);
    },
    checkNews(clickedNews: any) {
      // for (const news of this.newsList as any) {
      //   news.checked = true;
      // }
      for (const news of this.newsList as any) {
        if (news.news_id === clickedNews.news_id) {
          news.checked = true;
        }
      }
    },
    checkAlert(count: number) {
      this.alertCount = count;
    },
    addGtm() {
      if (process.env.VUE_APP_MODE === 'PROD') {
        const GTA = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-P4GTR75');`;
        const GTABody = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-P4GTR75" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
        const gtaScript: any = document.createElement('script');
        gtaScript.type = '';
        gtaScript.innerText = GTA;
        gtaScript.id = 'lp_gta';
        document.head.appendChild(gtaScript);
        const gtaBodyScript: any = document.createElement('noscript');
        gtaBodyScript.type = '';
        gtaBodyScript.innerText = GTABody;
        gtaBodyScript.id = 'lp_gta2';
        document.body.appendChild(gtaBodyScript);
      }
    },
    deleteGtm() {
      if (document.getElementById('lp_gta')) {
        (document.getElementById('lp_gta') as HTMLInputElement).remove();
      }
      if (document.getElementById('lp_gta2')) {
        (document.getElementById('lp_gta2') as HTMLInputElement).remove();
      }
    },
    async changeContract() {
      await this.check();
    },
    parentMethod(gaget: any) {
      this.ModalValue = gaget;
    },
    isAccountOnlyContract(contract: string) {
      // ログイン時にアカウント画面に遷移させる契約状態か判定
      switch (contract) {
        case NOC.CONTRACT.QUIT:
        case NOC.CONTRACT.CONFIRM:
        case NOC.CONTRACT.STOP:
          return true;
        default:
          return false;
      }
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, {}>);
